import React from 'react'

import AntIcon from '@ant-design/icons'

export interface IconProps {
  type?: string | any
  className?: string
  fontAwesome?: boolean
  onClick?: () => void
  style?: any
}

const Icon: React.FC<IconProps> = ({ type, className, fontAwesome = true, ...props }) => {
  return fontAwesome ? (
    <i className={`${type} ${className}`} onClick={props.onClick} {...props}></i>
  ) : (
    <AntIcon type={type} className={className} {...props} />
  )
}

export default Icon
